<div class="background-color-primary ">
  <div class="d-flex justify-content-center mt-5  container">
    <div class="row col-12 d-flex justify-content-center mt-5 mb-5 no-padding">
      <div class="col-12   row   d-flex justify-content-center  align-items-center   no-padding text-center "
        style="color: white;">


        <div class="row mt-4 d-flex justify-content-center">
          <div class="col-md-6 col-12">

            <h1>Gestión avanzada de eventos y locales.</h1>

            <h3>Promociona, vende y gestiona online entradas, listas de invitados y mesas VIP.</h3>
          </div>
        </div>

        <div class="row  d-flex justify-content-center ">
          <div class="col-12 col-md-6 row d-flex justify-content-center">
            <div class="col-6 col-md-6">
              <button routerLink="/admin" mat-stroked-button color="primary" class="col-12">
                Crear un lugar
              </button>
            </div>

            <div class="col-6 col-md-6">
              <button routerLink="/admin" class="col-12" mat-stroked-button color="primary">
                Crear un evento
              </button>
            </div>

            <div class="row d-flex justify-content-center">
              <h5 class="mt-4">¡Empieza ahora, es gratis!</h5>
              <button routerLink="/pricing" class="col-12 col-md-3" mat-stroked-button>
                Ver precios
              </button>
            </div>
          </div>

        </div>


        <div class="row mt-4 d-flex justify-content-center">
          <div class="col-12 col-md-6">
            <img src="https://images.xceed.me/static/b2cweb/business/landing-photo.png?w=800&ar=1.875:1&format=png"
              alt="" style="width: 100%;">
          </div>
        </div>
        <div class="row mt-4 d-flex justify-content-center">
          <div class="col-12 col-md-6">
            <h3>Desde discotecas hasta eventos de música en vivo y festivales, potencia tus acciones de marketing,
              vende
              más entradas y analiza métricas directamente desde la palma de tu mano.</h3>
          </div>


        </div>




      </div>



    </div>
  </div>
</div>


<div class="d-flex justify-content-center mt-5  container">
  <div class="row col-12 d-flex justify-content-center  mb-5 no-padding">
    <div class="col-12   row   d-flex justify-content-center  align-items-center   no-padding text-center ">



      <div class="row mt-4 d-flex justify-content-center">
        <div class="col-md-6 col-12">
          <h5>RESERVAS ONLINE</h5>
          <h1>Entradas, abonos, mesas y packs.
            Tu evento, tus reglas.</h1>

          <h3>Gestiona todas tus reservas en un solo lugar. Establece las reglas de visibilidad. Mantén un registro en
            tiempo real.</h3>
        </div>
      </div>


      <div class="row mt-4 d-flex justify-content-center">
        <div class="container-fluid col-12 col-md-12">
          <div class="container ">
            <div class="row">
              <div class="col-lg-4 col-md-12 mb-4">
                <div class="card h-100 shadow-lg">
                  <div class="card-body">
                    <div class="text-center p-3">
                      <h2 class="card-title">Gestiona listas de invitados</h2>
                      <!-- <small>Individual</small> -->
                      <!-- <br><br>
                        <span class="h2">$8</span>/month
                        <br><br> -->
                    </div>
                    <p class="card-text">Olvídate de las listas en papel y la contabilidad desordenada.
                      Monitoriza tus listas de invitados en tiempo real. Asigna acceso prioritario a clientes VIP y
                      staff.</p>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg> Contabilidad de promotores y otros canales de venta</li>
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg> Estadísticas en tiempo real y control de acceso</li>
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg> Añade invitados sobre la marcha</li>
                  </ul>
                  <div class="card-body text-center">
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 mb-4">
                <div class="card h-100 shadow-lg">
                  <div class="card-body">
                    <div class="text-center p-3">
                      <h2 class="card-title">Vende entradas online</h2>
                      <!-- <small>Small Business</small>
                        <br><br>
                        <span class="h2">$20</span>/month
                        <br><br> -->
                    </div>
                    <p class="card-text">Early birds, releases... ¡tú escoges el nombre!
                      Promociona tu venta de entradas con precios flexibles y optimiza tu estrategia con datos reales.
                    </p>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg>
                      Precios dinámicos</li>
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg> Establece cuotas y visibilidad</li>
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg> Vende inmediatamente</li>
                  </ul>
                  <div class="card-body text-center">
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 mb-4">
                <div class="card h-100 shadow-lg">
                  <div class="card-body">
                    <div class="text-center p-3">
                      <h2 class="card-title">Servicio de botellas y zonas VIP</h2>
                      <!-- <small>Large Companies</small>
                        <br><br>
                        <span class="h2">$40</span>/month
                        <br><br> -->
                    </div>
                    <p class="card-text">Vende botellas y mesas VIP y hazte con tu dinero incluso antes de que empiece
                      el evento con bonitos mapas personalizados de tu localización.</p>
                  </div>
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg> Crea tus propios mapas digitales ** proximamente</li>
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg> Upsell de packs y extras</li>
                    <li class="list-group-item"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                        <path
                          d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                      </svg> Integración in-evento</li>
                  </ul>
                  <div class="card-body text-center">
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>



    </div>
  </div>
</div>

<div class="background-color-primary " style="color: white;">
  <div class="d-flex justify-content-center mt-5  mb-5 container">
    <div class="row col-12 d-flex justify-content-center  mt-5 mb-5 no-padding">
      <div class="col-12   row   d-flex justify-content-center  align-items-center   no-padding text-center ">





        <div class="row mt-4 d-flex justify-content-center">
          <div class="col-md-6 col-12">
            <h5>CONTROL DE ACCESO</h5>
            <h1>Haz el check-in de tus asistentes a la velocidad de la luz.</h1>
            <h3>Recibe a los asistentes en puerta más rápido. Conecta tantos dispositivos como quieras y mantén los
              accesos y
              entradas VIP separados. Gestiona las entradas prioritarias mientras capturas los datos de los asistentes o
              actualizas las listas y perfiles de los asistentes.
              <!-- ¿No tienes conexión a internet? Calma, con las
              aplicaciones
              de Nigthgraph también puedes trabajar offline y sincronizar tus entradas después, en cuanto vuelvas a
              conectarte
              online. -->
            </h3>

            <div class="row mt-4 d-flex justify-content-center">
              <div class="col-md-12 col-12 row d-flex justify-content-center">



                <div class="col-12 col-md-6 d-flex   align-items-center mt-2 mb-2"> <mat-icon
                    mat-list-icon>phone_iphone</mat-icon> App
                  de
                  escáner multidispositivo </div>
                <div class="col-12 col-md-6   d-flex   align-items-center mt-2 mb-2"> <mat-icon
                    mat-list-icon>update</mat-icon> Tiempo
                  real
                </div>
                <div class="col-12 col-md-6   d-flex   align-items-center mt-2 mb-2"> <mat-icon
                    mat-list-icon>directions_run</mat-icon>
                  Captura los
                  walk-ins </div>
                <div class="col-12 col-md-6   d-flex   align-items-center mt-2 mb-2"> <mat-icon
                    mat-list-icon>barcode_reader</mat-icon>
                  Lectura
                  Barra y Accesos</div>

              </div>
            </div>
          </div>


          <div class="col-12 col-md-6 mt-4">
            <img src=" https://images.xceed.me/static/b2cweb/business/scan-app.png?w=800&ar=146:100&format=png" alt=""
              style="width: 100%;">
          </div>



        </div>




      </div>
    </div>
  </div>
</div>


<div class="d-flex justify-content-center mt-5  container">
  <div class="row col-12 d-flex justify-content-center  mb-5 no-padding">
    <div class="col-12   row   d-flex justify-content-center  align-items-center   no-padding text-center ">



      <div class="row mt-4 d-flex justify-content-center">
        <div class="col-md-6 col-12">
          <h5>ANÁLISIS Y PREVISIONES</h5>
          <h1>Toma el control de tus eventos. Hoy.</h1>

          <h3>Gestiona y monitoriza tus ventas con informes y análisis en tiempo real desde la palma de tu mano.</h3>
          <h3>Luego, traduce los datos en información procesable que conduzca a mayores beneficios y mejores estrategias
            de márketing.</h3>



          <div class="col-md-12 col-12 row d-flex justify-content-center ">

            <div class="col-12 col-md-12 d-flex   align-items-center justify-content-center  mt-2 mb-2"> <mat-icon
                mat-list-icon>stacked_line_chart</mat-icon> Estadísticas de reservas en tiempo real </div>
            <div class="col-12 col-md-12   d-flex   align-items-center  justify-content-center mt-2 mb-2"> <mat-icon
                mat-list-icon>price_check</mat-icon> Monitoraje de engagement y conversiones
            </div>
            <div class="col-12 col-md-12   d-flex   align-items-center  justify-content-center mt-2 mb-2"> <mat-icon
                mat-list-icon>money</mat-icon>
              Análisis de tráfico en horas punta </div>
            <div class="col-12 col-md-12   d-flex   align-items-center  justify-content-center mt-2 mb-2"> <mat-icon
                mat-list-icon>groups</mat-icon>
              Contabilidad de promotores y embajadores de marca **proximamente</div>
            <div class="col-12 col-md-12   d-flex   align-items-center  justify-content-center mt-2 mb-2"> <mat-icon
                mat-list-icon>analytics</mat-icon>
              Google Analytics integrados</div>

          </div>
        </div>


      </div>


      <div class="row mt-4 d-flex justify-content-center">

      </div>



    </div>
  </div>
</div>